<template>
  <div class="page">

    <!-- Angemeldet: Dashboard -->
    <template v-if="Benutzer.Angemeldet">
      <header class="dash-kopf">
        <p class="dash-gruss">{{ Begruessung }}</p>
        <h1 class="dash-name">{{ Benutzer.Name }}</h1>
        <span class="dash-raute">◆</span>
      </header>

      <router-link to="/wochenplanung" class="wochenplan-link">
        <span class="wochenplan-link-icon">
          <font-awesome-icon icon="fa-solid fa-utensils" />
        </span>
        <span class="wochenplan-link-text">Zur Wochenplanung</span>
      </router-link>

      <div class="speisekarte speisekarte--startseite">
        <div class="karte-ornament">✦</div>
        <h2 class="karte-titel">Menü des Tages</h2>
        <p class="karte-untertitel">{{ HeutigesDatum }}</p>
        <div class="karte-trenner">
          <span class="karte-trenner-linie"></span>
          <span class="karte-trenner-raute">◆</span>
          <span class="karte-trenner-linie"></span>
        </div>

        <template v-if="MenueDesTages.length > 0">
          <router-link
            v-for="Gericht in MenueDesTages"
            :key="Gericht.Kategorie"
            to="/wochenplanung"
            class="karte-gang"
          >
            <span class="karte-tag">{{ Gericht.Kategorie }}</span>
            <span class="karte-gericht">{{ Gericht.RezeptName }}</span>
          </router-link>
        </template>
        <p v-else class="karte-leer">Heute ist nichts geplant</p>

        <div class="karte-ornament karte-ornament--unten">✦</div>
      </div>

      <button type="button" class="abmelden-chip" @click="handleLogout">
        <font-awesome-icon icon="fa-solid fa-right-from-bracket" />
        Abmelden
      </button>
    </template>

    <!-- Nicht angemeldet: Auth-Karte -->
    <div v-else class="auth-bereich">
      <div class="marke">
        <span class="marke-logo">
          <font-awesome-icon icon="fa-solid fa-utensils" />
        </span>
        <h1 class="marke-name">TopfKucker</h1>
        <p class="marke-slogan">Planen. Kochen. Genießen.</p>
      </div>

      <div class="glas-karte auth-karte">
        <div class="segment-schalter">
          <button
            type="button"
            class="segment-option"
            :class="{ aktiv: Ansicht === 'login' }"
            @click="ZurueckZumLogin"
          >Anmelden</button>
          <button
            type="button"
            class="segment-option"
            :class="{ aktiv: Ansicht === 'registrieren' }"
            @click="ZurRegistrierungWechseln"
          >Registrieren</button>
        </div>

        <form v-if="Ansicht === 'login'" class="auth-form" @submit.prevent="handleLogin">
          <label for="email">E-Mail-Adresse</label>
          <div class="input-field">
            <font-awesome-icon icon="fa-solid fa-envelope" />
            <input id="email" v-model="email" type="email" placeholder="E-Mail-Adresse" autocomplete="username" />
          </div>

          <label for="password">Passwort</label>
          <div class="input-field">
            <font-awesome-icon icon="fa-solid fa-lock" />
            <input id="password" v-model="password" type="password" placeholder="Passwort" autocomplete="current-password" />
          </div>

          <label class="merken-zeile">
            <input v-model="AngemeldetBleiben" type="checkbox" />
            Angemeldet bleiben
          </label>

          <p v-if="ErfolgsHinweis" class="hint-message success">{{ ErfolgsHinweis }}</p>
          <p v-if="Fehlermeldung" class="error-message">{{ Fehlermeldung }}</p>

          <button
            v-if="EMailNichtBestaetigt"
            type="button"
            class="btn btn-secondary"
            @click="ErneutSenden"
          >
            <span class="btn-inhalt">
              <font-awesome-icon icon="fa-solid fa-envelope-circle-check" />
              Bestätigungs-E-Mail erneut senden
            </span>
          </button>

          <button type="submit" class="btn btn-primary auth-submit">
            <span class="btn-inhalt">
              <font-awesome-icon icon="fa-solid fa-arrow-right-to-bracket" />
              Anmelden
            </span>
          </button>
        </form>

        <form v-else class="auth-form" @submit.prevent="Anlegen">
          <label for="reg-email">E-Mail-Adresse</label>
          <div class="input-field">
            <font-awesome-icon icon="fa-solid fa-envelope" />
            <input id="reg-email" v-model="RegistrierenEMail" type="email" placeholder="E-Mail-Adresse" autocomplete="username" />
          </div>

          <label for="reg-password">Passwort</label>
          <div class="input-field">
            <font-awesome-icon icon="fa-solid fa-lock" />
            <input id="reg-password" v-model="RegistrierenPasswort" type="password" placeholder="Passwort" autocomplete="new-password" />
          </div>

          <label for="reg-password-repeat">Passwort wiederholen</label>
          <div class="input-field">
            <font-awesome-icon icon="fa-solid fa-lock" />
            <input id="reg-password-repeat" v-model="RegistrierenPasswortWiederholen" type="password" placeholder="Passwort wiederholen" autocomplete="new-password" />
          </div>

          <label for="reg-captcha">Sicherheitsprüfung</label>
          <div class="captcha-zeile">
            <img v-if="CaptchaBild" :src="CaptchaBild" alt="Captcha" class="captcha-bild" />
            <button type="button" class="captcha-neu" title="Neues Captcha laden" @click="CaptchaNeuLaden">
              <font-awesome-icon icon="fa-solid fa-rotate" />
            </button>
          </div>
          <div class="input-field">
            <font-awesome-icon icon="fa-solid fa-shield-halved" />
            <input id="reg-captcha" v-model="CaptchaEingabe" type="text" placeholder="Zeichen aus dem Bild" autocomplete="off" />
          </div>

          <p v-if="Fehlermeldung" class="error-message">{{ Fehlermeldung }}</p>

          <button type="submit" class="btn btn-primary auth-submit">
            <span class="btn-inhalt">
              <font-awesome-icon icon="fa-solid fa-user-plus" />
              Konto anlegen
            </span>
          </button>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import { Benutzer, Anmelden, Registrieren, Abmelden, CaptchaLaden, BestaetigungErneutSenden } from '../composables/useBenutzer'
import { Wochenplanpositionen, WochenplanungLaden } from '../composables/useWochenplanung'

const KategorieReihenfolge = ['Frühstück', 'Vorspeise', 'Hauptgang', 'Nachspeise', 'Abendessen']

function HeutigesDatumString() {
  const Heute = new Date()
  const Jahr = Heute.getFullYear()
  const Monat = String(Heute.getMonth() + 1).padStart(2, '0')
  const Tag = String(Heute.getDate()).padStart(2, '0')
  return `${Jahr}-${Monat}-${Tag}`
}

export default {
  name: 'HomeView',
  data() {
    return {
      Benutzer,
      Wochenplanpositionen,
      email: '',
      password: '',
      AngemeldetBleiben: false,
      Fehlermeldung: '',
      ErfolgsHinweis: '',
      EMailNichtBestaetigt: false,
      Ansicht: 'login',
      RegistrierenEMail: '',
      RegistrierenPasswort: '',
      RegistrierenPasswortWiederholen: '',
      CaptchaBild: '',
      CaptchaEingabe: ''
    }
  },
  computed: {
    Begruessung() {
      const Stunde = new Date().getHours()
      if (Stunde < 11) return 'Guten Morgen'
      if (Stunde < 18) return 'Guten Tag'
      return 'Guten Abend'
    },
    HeutigesDatum() {
      const Heute = new Date()
      const Wochentage = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
      const Monate = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
      return `${Wochentage[Heute.getDay()]}, ${Heute.getDate()}. ${Monate[Heute.getMonth()]}`
    },
    MenueDesTages() {
      const Heute = HeutigesDatumString()
      return this.Wochenplanpositionen
        .filter(Position => Position.Datum === Heute)
        .slice()
        .sort((a, b) => KategorieReihenfolge.indexOf(a.Kategorie) - KategorieReihenfolge.indexOf(b.Kategorie))
    }
  },
  watch: {
    'Benutzer.Angemeldet': {
      immediate: true,
      handler(Angemeldet) {
        if (Angemeldet) {
          WochenplanungLaden()
        }
      }
    }
  },
  methods: {
    async handleLogin() {
      this.Fehlermeldung = ''
      this.ErfolgsHinweis = ''
      this.EMailNichtBestaetigt = false
      try {
        await Anmelden(this.email, this.password, this.AngemeldetBleiben)
      } catch (Fehler) {
        this.Fehlermeldung = Fehler.message
        this.EMailNichtBestaetigt = !!(Fehler.Daten && Fehler.Daten.EMailNichtBestaetigt)
      }
    },
    ZurRegistrierungWechseln() {
      this.Fehlermeldung = ''
      this.ErfolgsHinweis = ''
      this.EMailNichtBestaetigt = false
      this.RegistrierenEMail = this.email
      this.RegistrierenPasswort = ''
      this.RegistrierenPasswortWiederholen = ''
      this.CaptchaEingabe = ''
      this.Ansicht = 'registrieren'
      this.CaptchaNeuLaden()
    },
    ZurueckZumLogin() {
      this.Fehlermeldung = ''
      this.Ansicht = 'login'
    },
    async CaptchaNeuLaden() {
      this.CaptchaEingabe = ''
      try {
        const Daten = await CaptchaLaden()
        this.CaptchaBild = Daten.Bild
      } catch (Fehler) {
        this.CaptchaBild = ''
        this.Fehlermeldung = 'Captcha konnte nicht geladen werden. Bitte Verbindung prüfen.'
      }
    },
    async Anlegen() {
      this.Fehlermeldung = ''
      if (this.RegistrierenPasswort !== this.RegistrierenPasswortWiederholen) {
        this.Fehlermeldung = 'Die Passwörter stimmen nicht überein.'
        return
      }
      try {
        await Registrieren(this.RegistrierenEMail, this.RegistrierenPasswort, this.CaptchaEingabe)
        this.email = this.RegistrierenEMail
        this.Ansicht = 'login'
        this.ErfolgsHinweis = `Fast geschafft! Wir haben dir eine E-Mail an ${this.RegistrierenEMail} geschickt. `
          + 'Bitte klicke auf den Bestätigungslink darin, um dein Konto freizuschalten.'
      } catch (Fehler) {
        this.Fehlermeldung = Fehler.message
        this.CaptchaNeuLaden()
      }
    },
    async ErneutSenden() {
      this.Fehlermeldung = ''
      this.EMailNichtBestaetigt = false
      try {
        await BestaetigungErneutSenden(this.email)
        this.ErfolgsHinweis = 'Die Bestätigungs-E-Mail wurde erneut gesendet. Bitte schau in dein Postfach.'
      } catch (Fehler) {
        this.Fehlermeldung = Fehler.message
      }
    },
    async handleLogout() {
      await Abmelden()
    }
  },
  mounted() {
    const Bestaetigt = this.$route.query.EMailBestaetigt
    if (Bestaetigt === '1') {
      this.ErfolgsHinweis = 'Deine E-Mail-Adresse ist bestätigt. Du kannst dich jetzt anmelden.'
    } else if (Bestaetigt === '0') {
      this.Fehlermeldung = 'Der Bestätigungslink ist ungültig oder wurde bereits verwendet.'
    }
    if (Bestaetigt !== undefined) {
      this.$router.replace({ query: {} })
    }
  }
}
</script>

<style scoped>
/* ── Dashboard ───────────────────────────────────────── */
.dash-kopf {
  --karte-gold: #A8894B;
  margin: 4px 0 22px;
  text-align: center;
  font-family: Georgia, 'Times New Roman', serif;
}

html[data-theme="dark"] .dash-kopf {
  --karte-gold: #CBB26A;
}

.dash-gruss {
  margin: 0;
  font-size: 0.95rem;
  font-style: italic;
  letter-spacing: 0.05em;
  color: var(--color-text-muted);
}

.dash-name {
  margin: 4px 0 10px;
  font-size: 2rem;
  font-weight: 400;
  letter-spacing: 0.01em;
  color: var(--color-text);
}

.dash-raute {
  display: inline-block;
  color: var(--karte-gold);
  font-size: 0.6rem;
}

/* ── Link zur Wochenplanung (gleicher Menükarten-Stil) ── */
.wochenplan-link {
  --karte-gold: #A8894B;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: min(480px, 100%);
  margin: 0 auto 18px;
  padding: 12px 20px;
  border: 1px solid color-mix(in srgb, var(--karte-gold) 40%, transparent);
  border-radius: 999px;
  background: color-mix(in srgb, var(--karte-gold) 6%, transparent);
  text-decoration: none;
  transition: background-color 0.2s ease, transform 0.15s ease, border-color 0.2s ease;
}

html[data-theme="dark"] .wochenplan-link {
  --karte-gold: #CBB26A;
}

.wochenplan-link:hover {
  background: color-mix(in srgb, var(--karte-gold) 14%, transparent);
  border-color: color-mix(in srgb, var(--karte-gold) 65%, transparent);
  transform: translateY(-1px);
}

.wochenplan-link-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--karte-gold);
  font-size: 1.05rem;
}

.wochenplan-link-text {
  font-family: Georgia, 'Times New Roman', serif;
  font-style: italic;
  font-size: 1rem;
  letter-spacing: 0.03em;
  color: var(--color-text);
}

.abmelden-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 28px;
  padding: 9px 18px;
  border: none;
  border-radius: 999px;
  background: color-mix(in srgb, var(--color-danger) 10%, transparent);
  color: var(--color-danger);
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.15s ease;
}

.abmelden-chip:hover {
  background: color-mix(in srgb, var(--color-danger) 18%, transparent);
  transform: translateY(-1px);
}

/* ── Auth ────────────────────────────────────────────── */
.auth-bereich {
  max-width: 420px;
  margin: 4vh auto 0;
}

.marke {
  text-align: center;
  margin-bottom: 24px;
}

.marke-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: linear-gradient(135deg, var(--color-primary), var(--akzent-tief));
  color: #fff;
  font-size: 1.5rem;
  box-shadow: 0 10px 30px color-mix(in srgb, var(--color-primary) 40%, transparent);
  margin-bottom: 14px;
}

.marke-name {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  background: linear-gradient(120deg, var(--color-primary), var(--color-accent));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.marke-slogan {
  margin: 4px 0 0;
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.auth-karte {
  padding: 20px;
}

.auth-form {
  display: flex;
  flex-direction: column;
  margin-top: 18px;
}

.auth-form label {
  margin-top: 14px;
  margin-bottom: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text-muted);
}

.auth-form label:first-child {
  margin-top: 0;
}

.auth-submit {
  margin-top: 22px;
}

.merken-zeile {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-text-muted);
  cursor: pointer;
  user-select: none;
}

.merken-zeile input {
  width: 16px;
  height: 16px;
  accent-color: var(--color-primary);
  cursor: pointer;
}

.captcha-zeile {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-bild {
  height: 52px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
}

.captcha-neu {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  background: none;
  color: var(--color-text-muted);
  font-size: 0.95rem;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;
}

.captcha-neu:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
}

/* ── Menü des Tages (gleiches Layout wie die Speisekarte der Wochenplanung) ── */
.speisekarte--startseite {
  --karte-gold: #A8894B;
  position: relative;
  width: min(480px, 100%);
  margin: 28px auto 0;
  padding: 30px 22px 26px;
  text-align: center;
  font-family: Georgia, 'Times New Roman', serif;
  background: var(--glas-stark);
  -webkit-backdrop-filter: var(--glas-blur);
  backdrop-filter: var(--glas-blur);
  border: 1px solid var(--glas-rand);
  border-radius: var(--radius-lg);
  box-shadow: var(--glas-schatten);
}

html[data-theme="dark"] .speisekarte--startseite {
  --karte-gold: #CBB26A;
}

.speisekarte--startseite::before {
  content: '';
  position: absolute;
  inset: 9px;
  border: 1px solid color-mix(in srgb, var(--karte-gold) 40%, transparent);
  border-radius: calc(var(--radius-lg) - 7px);
  pointer-events: none;
}

.speisekarte--startseite .karte-ornament {
  color: var(--karte-gold);
  font-size: 0.8rem;
  letter-spacing: 0.5em;
  margin-bottom: 10px;
}

.speisekarte--startseite .karte-ornament--unten {
  margin-bottom: 0;
  margin-top: 18px;
}

.speisekarte--startseite .karte-titel {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  color: var(--color-text);
}

.speisekarte--startseite .karte-untertitel {
  margin: 6px 0 0;
  font-style: italic;
  font-size: 0.85rem;
  color: var(--color-text-muted);
}

.speisekarte--startseite .karte-trenner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 18px auto 20px;
  max-width: 240px;
}

.speisekarte--startseite .karte-trenner-linie {
  flex: 1;
  height: 1px;
  background: color-mix(in srgb, var(--karte-gold) 45%, transparent);
}

.speisekarte--startseite .karte-trenner-raute {
  color: var(--karte-gold);
  font-size: 0.55rem;
}

.speisekarte--startseite .karte-gang {
  display: block;
  width: 100%;
  padding: 10px 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  color: inherit;
  text-decoration: none;
  transition: transform 0.2s ease;
}

.speisekarte--startseite .karte-gang + .karte-gang {
  position: relative;
  margin-top: 8px;
  padding-top: 18px;
}

.speisekarte--startseite .karte-gang + .karte-gang::before {
  content: '·';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  color: var(--karte-gold);
  font-size: 1rem;
  line-height: 1;
}

.speisekarte--startseite .karte-gang:hover {
  transform: translateY(-1px);
}

.speisekarte--startseite .karte-tag {
  display: block;
  font-size: 0.66rem;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  color: var(--karte-gold);
  margin-bottom: 4px;
}

.speisekarte--startseite .karte-gericht {
  display: block;
  font-size: 1.18rem;
  font-style: italic;
  line-height: 1.35;
  color: var(--color-text);
  transition: color 0.2s ease;
}

.speisekarte--startseite .karte-gang:hover .karte-gericht {
  color: var(--karte-gold);
}

.speisekarte--startseite .karte-leer {
  margin: 0;
  font-style: italic;
  font-size: 0.9rem;
  color: var(--color-text-muted);
}
</style>
